import React from 'react'
import clsx from 'clsx'

function TabElement({title,subtitle,name,activename,handleclick}) {
    const status = name === activename ? "active" : "inactive"
  return (
    <div className="d-flex align-items-center mb-4 bg-hover-light rounded p-2" onClick={()=>handleclick(name)}>
        <div className="flex-grow-1">
            <div className="text-gray-800 fw-bold fs-6">{title && title}</div>
            <div className="text-muted fw-bold fs-7">{subtitle && subtitle}</div>
        </div>
        <span className={clsx("bullet","bullet-vertical","h-40px","me-3",{"bg-success":status === "active"})}></span>
    </div>
  )
}

export default TabElement